import "./PersonalProjectCard.css";

const colors = [
  "#A2D2FF",
  "#FFC8DD",
  "#CDB4DB",
  "#B5EAD7",
  "#FFDAC1",
  "#E0BBE4",
  "#FDCB9E",
];

export const SkillTags = ({ skills = ["cat", "dog"] }) => {
  return (
    <div className="tag-container">
      {skills?.map((skill, index) => (
        <span
          key={index}
          className="skill-tag"
          style={{
            backgroundColor: colors[index % colors.length],
            border: "none",
          }}
        >
          {skill}
        </span>
      ))}
    </div>
  );
};
